"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const CustomOTPInput = ({ errorMessage, onCodeFilled }) => {
    const [inputs, setInputs] = (0, react_1.useState)(Array(6).fill(""));
    const inputRefs = (0, react_1.useRef)([]);
    const handleInput = (text, index) => {
        const newInputs = [...inputs];
        newInputs[index] = text;
        setInputs(newInputs);
        // Tự động chuyển đến input tiếp theo
        if (text.length === 1 && index < 5) {
            inputRefs.current[index + 1]?.focus();
        }
        // Kiểm tra và gửi mã hoàn chỉnh
        if (newInputs.every(input => !!input)) {
            onCodeFilled?.(newInputs.join(""));
        }
        else {
            onCodeFilled?.("");
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.View, { style: styles.container }, inputs.map((input, index) => (react_1.default.createElement(react_native_1.TextInput, { key: index, style: styles.input, value: input, onChangeText: (text) => handleInput(text, index), onKeyPress: (e) => {
                if (e.nativeEvent.key === 'Backspace') {
                    const newInputs = [...inputs];
                    newInputs[index] = "";
                    setInputs(newInputs);
                    inputRefs.current[index - 1]?.focus();
                    onCodeFilled?.("");
                }
            }, maxLength: 1, keyboardType: "numeric", ref: (ref) => {
                inputRefs.current[index] = ref;
            } })))),
        !!errorMessage && (react_1.default.createElement(CustomText_1.default, { style: styles.textError }, errorMessage))));
};
const styles = react_native_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: (0, scale_1.scale)(8),
    },
    input: {
        width: (0, scale_1.scale)(34),
        height: (0, scale_1.scale)(40),
        fontSize: (0, scale_1.moderateScale)(15),
        fontFamily: 'Hiragino Kaku Gothic Pro W3',
        borderWidth: 1,
        backgroundColor: '#fefefe',
        borderColor: '#C8C8C8',
        textAlign: 'center',
        borderRadius: (0, scale_1.scale)(3),
    },
    textError: {
        color: '#F80F63',
        fontSize: (0, scale_1.moderateScale)(12),
        marginTop: (0, scale_1.scale)(8),
        lineHeight: (0, scale_1.scale)(16),
    },
});
exports.default = CustomOTPInput;
